import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { Mailtrap } from 'src/app/interfaces/mailtrap.interface';

@Injectable()
export class MailtrapService {

    private url = `${environment.api}/mail/`;
    constructor(private http: HttpClient) { }

    send(mailtrap: Mailtrap): Observable<any> {
        return this.http.post<any>(`${this.url}/send`, mailtrap);
    }
    
    
}
